import Vue from 'vue';
import router from '@/router/index.js';
import store from '@/store/index.js';
import messageTips from '@/utils/message.js';
import { handleRequestCancel, handleResponseCancel } from './cancel-same-request.js';
import { isCancel } from 'axios';

export default {
  init() {
    this.setHeaders();
    Vue.axios.interceptors.response.use(...handleResponseCancel);
    Vue.axios.interceptors.response.use(response => {
      if (response && response.data.code === '999') {
        store.commit('SIGNIN_OUT');
        router.push('/signin');
        return;
      }
      if (response.status === 200) {
        const requestUrl = response.config.url;
        const arr = ['/api/v1.0/chanquan/user/login', '/api/v1.0/chanquan/user/verifyLogin'];
        if (arr.includes(requestUrl)) { // 登录
          store.commit('SET_USER_INFO', response.data.data);
        }
        return response && response.data;
      } else {
        console.log('【响应-异常】', response);
        return;
      }
    }, error => {
      // 如果是取消请求则不返回
      if (isCancel(error)) {
        return;
      }
      console.log('【异常】', error.response);
      const status = error.response.status;
      if (status && /4\d\d/.test(status)) {
        switch (status) {
        case 404:
          console.error('404 Not Found!');
          break;
        case 406:
          const code = error.response && error.response.data && error.response.data.code;
          if (code && code === '999') {
            store.commit('SIGNIN_OUT');
            router.push('/signin');
            break;
          } else if (code && code === '998') {
            store.commit('SIGNIN_OUT');
            router.push('/signin');
            if(error.response && error.response.data && error.response.data.reason) {
              messageTips.errorMessage(error.response && error.response.data && error.response.data.reason);
              break;
            } else {
              break;
            }
          }
          console.error('406 error');
          break;
        default:
          console.error('出错啦，请稍后再试');
        }
        // messageTips.errorMessage(error.response && error.response.data && error.response.data.reason);
        return Promise.reject(error.response);
      }
      if (status === 0) {
        console.error('ajax timeout error: 网络不给力，数据请求超时，请稍后再试');
        router.push('/error');
        return Promise.reject(error.response);
      }
      if (status === 503) {
        // messageTips.errorMessage('系统重启中，请稍后再试');
        return Promise.reject(error.response);
      }
      // messageTips.errorMessage('系统异常，请稍后再试');
      return Promise.reject(error.response);
    });
  },
  setHeaders() {
    Vue.axios.interceptors.request.use(...handleRequestCancel);
    Vue.axios.defaults.timeout = 1000 * 5 * 60;
    Vue.axios.interceptors.request.use(
      config => {
        const token = store.getters.userInfo.accessToken;
        const tenantObj = store.getters.getTenantParams; // 租户id,跟区域相关
        config.headers['TENANT-ID'] = tenantObj.tId || '99999999999999';
        if (token) {
          config.headers['Authorization'] = token;
        }
        // 支付类接口 后端添加防双击
        let clickTokenList = [
          '/api/v1.0/chanquan/bid/paymentFee',
          '/api/v1.0/chanquan/project/payContract',
          '/api/v1.0/chanquan/center/paymentProjectFund'
        ];
        const clickToken = store.getters.clickToken;
        if(clickTokenList.includes(config.url)) {
          config.headers['DubboClickToken'] = clickToken;
        }

        const interFacelist = [
          '/api/v1.0/chanquan/news/selectNewsListByPage',
          '/api/v1.0/chanquan/purchase/purchaseList',
          '/api/v1.0/chanquan/project/selectTradePro',
          '/api/v1.0/chanquan/project/selectAllBidList',
          '/api/v1.0/chanquan/notice/purchase/transactionAnnouncementList',
          '/api/v1.0/chanquan/notice/purchase/getTransactionAnnouncementInfo',
          '/api/v1.0/chanquan/project/getAuctionResultsAnnouncementContractInfo',
          '/api/v1.0/chanquan/notice/purchase/tradingVerificationList',
          '/api/v1.0/chanquan/notice/purchase/getTradingVerificationDetails',
          '/api/v1.0/chanquan/project/selectBidList',
          '/api/v1.0/chanquan/notice/purchase/centralizedTradingList'
        ];
        if(interFacelist.includes(config.url)) {
          if(config.method === 'post') {
            // if(Number(localStorage.level) === 2) {
            //   config.data.city = config.data.city || localStorage.areaCode;
            // } else if(Number(localStorage.level) === 3) {
            //   config.data.county = localStorage.areaCode;
            // } else if(Number(localStorage.level) === 4){
            //   config.data.township = localStorage.areaCode;
            // }

            let paramsCity = config.data.city;
            let areaCode = localStorage.areaCode;

            // 如果传过来的city有值
            if(paramsCity) {
              areaCode = paramsCity;
            }

            if(areaCode && areaCode.length === 4) {
              config.data.city = areaCode;
            } else if(areaCode && areaCode.length === 6) {
              config.data.county = areaCode;
              config.data.city && delete config.data.city;
            } else if(areaCode && areaCode.length === 9){
              config.data.township = areaCode;
              config.data.city && delete config.data.city;
            } else if(areaCode && areaCode.length === 12){
              config.data.village = areaCode;
              config.data.city && delete config.data.city;
            }
          }
          // 新闻传参areaCode
          if(config.url === '/api/v1.0/chanquan/news/selectNewsListByPage') {
            config.data.areaCode = localStorage.areaCode || 23;
          }
        }
        return config;
      },
      error => {;
        console.log(error);
        Promise.reject(error);
      }
    );
  }
};
